import { render } from "./CreditRequestIncome.vue?vue&type=template&id=b613913e"
import script from "./CreditRequestIncome.vue?vue&type=script&lang=js"
export * from "./CreditRequestIncome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__